import { render, staticRenderFns } from "./active-setting.vue?vue&type=template&id=4e723be3&scoped=true"
import script from "./active-setting.vue?vue&type=script&lang=js"
export * from "./active-setting.vue?vue&type=script&lang=js"
import style0 from "./active-setting.vue?vue&type=style&index=0&id=4e723be3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e723be3",
  null
  
)

export default component.exports